module.exports = __webpack_public_path__ + "img/4.b5a33a86.jpg";